import {Editor} from "slate";

type MarkType = "bold" | "italic" | "underline";

/**
 * Checks for a mark (inline format, like bold or italic) at the current
 * selection.
 */
export const isMarkActive = (editor: Editor, markType: MarkType): boolean => {
    const marks = Editor.marks(editor);
    return marks ? marks[markType] === true : false;
};

/**
 * Toggles a mark (inline format, like bold or italic) at the current
 * selection.
 */
export const toggleMark = (editor: Editor, markType: MarkType) => {
    const isActive = isMarkActive(editor, markType);

    if (isActive) {
        Editor.removeMark(editor, markType);
    } else {
        Editor.addMark(editor, markType, true);
    }
};
